import React from "react"
import { Button, Form } from "react-bootstrap"
import { blockingFetchService } from "../../../lib/blockingFetch"
import { glAccountsDataWithId, sortGLAccounts, validateTextState, VALIDATION_TYPE } from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import FormControlInlineCheckbox from "../../fragments/FormControl.Inline.Checkbox"
import FormControlInlineInput from "../../fragments/FormControl.Inline.Input"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import FormControlInlineTextArea from "../../fragments/FormControl.Inline.TextArea"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { browserHistory } from "react-router"
import FontAwesome from "react-fontawesome"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"

class FormAccountingRule extends React.Component {

  constructor(props) {
    super(props)

    const { accountingRule } = this.props,
    isNew = !accountingRule

    this.state = {
      isNew,
      running: false,
      success: false,
      error: null,
      name: isNew ? '' : accountingRule.name,
      accountToDebit: (isNew || !accountingRule.accountToDebit) ? '' : accountingRule.accountToDebit.id,
      accountToCredit: (isNew || !accountingRule.accountToCredit) ? '' : accountingRule.accountToCredit.id,
      description: isNew ? '' : accountingRule.description,
      allowMultipleDebitEntries: isNew ? false : accountingRule.allowMultipleDebitEntries,
      allowMultipleCreditEntries: isNew ? false : accountingRule.allowMultipleCreditEntries,

      nameValidationState: VALIDATION_TYPE.NULL,
      accountToDebitValidationState: VALIDATION_TYPE.NULL,
      accountToCreditValidationState: VALIDATION_TYPE.NULL,
      descriptionValidationState: VALIDATION_TYPE.NULL,
    }
  }

  componentDidMount() {

    this.props.loadData()
    const { isNew } = this.state
    if(!isNew) {
      this.validateAllValues()
    }
  }

  nameChanged = name => this.setState({
    name,
    nameValidationState: validateTextState(name, false),
    error: null,
  })

  accountToDebitChanged = accountToDebit => this.setState({
    accountToDebit,
    accountToDebitValidationState: validateTextState(accountToDebit, false),
    error: null,
  })

  accountToCreditChanged = accountToCredit => this.setState({
    accountToCredit,
    accountToCreditValidationState: validateTextState(accountToCredit, false),
    error: null,
  })

  descriptionChanged = description => this.setState({
    description,
    descriptionValidationState: validateTextState(description, true),
    error: null,
  })

  allowMultipleDebitEntriesChanged = () =>
    this.setState({ allowMultipleDebitEntries: !this.state.allowMultipleDebitEntries })

  allowMultipleCreditEntriesChanged = () =>
    this.setState({ allowMultipleCreditEntries: !this.state.allowMultipleCreditEntries })
  
  validateAllValues = () => {

    const { name, accountToDebit, accountToCredit, description } = this.state
    this.setState({
      nameValidationState: validateTextState(name, false),
      accountToDebitValidationState: validateTextState(accountToDebit, false),
      accountToCreditValidationState: validateTextState(accountToCredit, false),
      descriptionValidationState: validateTextState(description, true),
    })
  }

  valid = () => {

    const { name, accountToDebit, accountToCredit, description } = this.state
    return (
      validateTextState(name, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(accountToDebit, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(accountToCredit, false) === VALIDATION_TYPE.SUCCESS &&
      validateTextState(description, true) !== VALIDATION_TYPE.ERROR
    )
  }

  saveClicked = () => {

    if(this.valid()) {
      this.saveData()
    }
    else {
      this.validateAllValues()
      this.setState({ error: 'Some fields are incorrect.' })
    }
  }

  saveData = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { isNew, name, accountToDebit, accountToCredit, description, allowMultipleDebitEntries,
      allowMultipleCreditEntries } = this.state,

    data = {
      name,
      accountToDebit: { id: accountToDebit },
      accountToCredit: { id: accountToCredit },
      description,
      allowMultipleDebitEntries,
      allowMultipleCreditEntries
    },

    { accountingRule } = this.props

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.createAccountingRule(accessToken, data)
        : apiServerApi.updateAccountingRule(accessToken, accountingRule.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(() => browserHistory.push('/accountingrules'), 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderForm = () => {

    const { isNew, error, success, running, name, accountToDebit, accountToCredit, description,
      allowMultipleDebitEntries, allowMultipleCreditEntries, nameValidationState, descriptionValidationState,
      accountToDebitValidationState, accountToCreditValidationState  } = this.state,

      { glAccounts } = this.props,

      glAccountsData = glAccountsDataWithId(glAccounts)

    return (
      <div className="simple-form max-width-700 mx-auto mb-20">
        <Form horizontal onSubmit={e => { e.preventDefault(); this.saveClicked()}}>

          <h3 className="text-center">
            { isNew ? 'New Accounting rule' : 'Update Accounting rule' }
          </h3>
          <hr />

          <FormControlInlineInput controlId="name" validationState={ nameValidationState }
            label='Name' placeholder='Enter name' value={ name }
            onChange={ this.nameChanged }
            helpText={ nameValidationState === VALIDATION_TYPE.ERROR ? 'Name is required' : '' }
          />

          <FormControlInlineSelect
            controlId='accountToDebit' validationState={ accountToDebitValidationState }
            label='Account to debit' value={ accountToDebit } 
            onChange={ this.accountToDebitChanged }
            options={ glAccountsData }
            withEmptyOption={ true }
            helpText={ accountToDebitValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
          />

          <FormControlInlineSelect
            controlId='accountToCredit' validationState={ accountToCreditValidationState }
            label='Account to credit' value={ accountToCredit } 
            onChange={ this.accountToCreditChanged }
            options={ glAccountsData }
            withEmptyOption={ true }
            className=''
            helpText={ accountToCreditValidationState === VALIDATION_TYPE.ERROR ? 'Choose an account' : '' }
          />

          <FormControlInlineTextArea
            controlId='description' validationState={ descriptionValidationState }
            label='Description (Optional)' value={ description }
            onChange={ this.descriptionChanged }
          />

          <FormControlInlineCheckbox
            controlId='allowMultipleDebitEntries' label='Allow multiple debit entries'
            validationState={ VALIDATION_TYPE.NULL } value={ allowMultipleDebitEntries }
            onChange={ this.allowMultipleDebitEntriesChanged }
          />

          <FormControlInlineCheckbox
            controlId='allowMultipleCreditEntries' label='Allow multiple credit entries'
            validationState={ VALIDATION_TYPE.NULL } value={ allowMultipleCreditEntries }
            onChange={ this.allowMultipleCreditEntriesChanged }
          />
        </Form>

        <ProcessesStatus error={ error } running={ running } success={ success } />

        <div className="align-right mt-30">
          <Button onClick={() => browserHistory.push('/accountingrules')} className="w-100" disabled={ running }>
            <FontAwesome name='close' /> Cancel
          </Button>

          &nbsp; &nbsp;
          <Button bsStyle="success" onClick={ this.saveClicked } className="w-120" disabled={ running }>
            <FontAwesome name='save' /> Save
          </Button>
        </div>
      </div>
    )
  }

  render() {
    const { isNew } = this.state,
    dataBreadCrumbs = [{ url: '/accounting', title: 'Accounting' }, { url: '/accountingrules', title: 'Accounting rules' }]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ dataBreadCrumbs } />
        { this.renderForm() }
      </div>
    )
  }
}

const mapStateToProps = state => {
  const glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  sortGLAccounts(glAccounts)
  return { glAccounts }
}

const mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FormAccountingRule)



// WEBPACK FOOTER //
// ./src/components/Accounting/AccountingRules/Form.js